import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Surfaced to the UI by ConfigError boundary in main.tsx instead of thrown
// at module load (which used to silently blank-screen the SPA).
export const supabaseConfigError: string | null =
  !url || !anonKey
    ? "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set at build time. " +
      "See README ops runbook for GitHub Actions repository-variable setup."
    : null;

// When config is missing we still create a client against a placeholder so
// `import { supabase }` doesn't crash. The UI gates on supabaseConfigError
// before letting anything that touches Supabase run.
export const supabase = createClient(
  url || "https://placeholder.supabase.co",
  anonKey || "placeholder",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
